import { useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-foreground-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6 text-foreground-900">这个页面不存在</h1>
        <p className="mt-2 text-base text-foreground-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-foreground-500">你访问的页面可能已被移除，或者输入的地址有误</p>
        <Link
          to="/"
          className="mt-6 inline-flex items-center whitespace-nowrap rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition hover:bg-primary-600"
        >
          <i className="ri-home-4-line mr-2"></i>
          返回动漫网首页
        </Link>
      </div>
    </div>
  );
}